import axios from 'axios'
import { Notification } from 'element-ui'
import store from '@/store'
import { getToken, getLogin, setLogin } from '@/utils/auth'
import router from '@/router'

const JSONbigString = require('json-bigint')({ 'storeAsString': true })
// axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
// create an axios instance
const BASE_URL = 'http://118.178.243.127:9038'
const service = axios.create({
  baseURL: BASE_URL, // api的base_url
  timeout: 5000000 // request timeout
})

// request interceptor
service.interceptors.request.use(config => {
  config.headers['type'] = 'web_emp'
  if (store.getters.token) {
    config.headers['token'] = getToken()
  }
  return config
}, error => {
  // Do something with request error
  Promise.reject(error)
})
service.defaults.transformResponse = [
  function (data) {
    return JSONbigString.parse(data)
  }
]
// respone interceptor
service.interceptors.response.use(
  // response => response,
  response => {
    const res = response.data
    if (res.code === 250) {
      store.dispatch('removeUser', null).then(() => {
        router.push({ path: '/login' })
      })
      let isLogin = getLogin()
      if (!isLogin || isLogin === 'false') {
        setLogin(true)
        Notification.warning({
          title: '警告',
          message: '您已被登出，请重新登录！如果不是您本人操作，请及时更换密码',
          type: 'warning'
        })
      }
      return Promise.reject(new Error('error'))
    } else {
      return response
    }
  },
  error => {
    // Message({
    //   message: error.message,
    //   type: 'error',
    //   duration: 5 * 1000
    // })
    return Promise.reject(error)
  })

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js